// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.26.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// JS extensions and helpers for Bootstrap's Navbar component
// -----------------------------------------------------------------------------

import Shadow from './shadow'

const Navbar = (($) => {
  const Selectors = {
    NAV_TRANS: '.navbar-trans',
    NAVBAR_MAIN: '#js-navbar-main',
    NAVBAR_TOGGLER_ICON: '.navbar-toggler__icon',
    COLLAPSE: '.collapse'
  }

  const Class = {
    NAVBAR_TOGGLER_ICON_OPEN: 'navbar-toggler__icon--open'
  }

  const Event = {
    COLLAPSE_HIDE: 'hide.bs.collapse',
    COLLAPSE_HIDDEN: 'hidden.bs.collapse',
    COLLAPSE_SHOW: 'show.bs.collapse'
  }

  let $collapse = $()

  function initNavbarTrans () {
    const scrollTarget = 64

    for (let nav of $(Selectors.NAV_TRANS)) {
      const $nav = $(nav)
      $nav.addClass('u-transition--bg')

      toggleNavTransState($nav, scrollTarget)

      $(window).scroll(() => {
        toggleNavTransState($nav, scrollTarget)
      })
    }
  }

  function toggleNavTransState ($nav, scrollTarget) {
    const navTransRaw = Selectors.NAV_TRANS.split('.').join('')

    if ($(window).scrollTop() > scrollTarget) {
      $nav.removeClass(navTransRaw)
    } else {
      $nav.addClass(navTransRaw)
    }
  }

  function initNavbarTogglerState () {
    if ($collapse.length) {
      const $togglerIcon = $(Selectors.NAVBAR_TOGGLER_ICON)

      $collapse.on(Event.COLLAPSE_SHOW, () => {
        $togglerIcon.addClass(Class.NAVBAR_TOGGLER_ICON_OPEN)
      })

      $collapse.on(Event.COLLAPSE_HIDE, () => {
        $togglerIcon.removeClass(Class.NAVBAR_TOGGLER_ICON_OPEN)
      })
    }
  }

  // Resize the main navbar's shadow div on collapse close event to ensure shadow
  // height matches navbar height (and pushes subsquent content down by the
  // appropriate amount).
  function initSyncShadowOnCollapse () {
    // Only add event listener if collapse exists
    if ($collapse.length) {
      $collapse.on(Event.COLLAPSE_HIDDEN, () => {
        Shadow.sync(Selectors.NAVBAR_MAIN)
      })
    }
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  let Navbar = {
    init () {
      $collapse = $(Selectors.NAVBAR_MAIN).find(Selectors.COLLAPSE)

      Shadow.init()
      initNavbarTrans()
      initSyncShadowOnCollapse()
      initNavbarTogglerState()
    }
  }

  return Navbar
})(jQuery)

export default Navbar
